"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = require("@react-pdf/renderer");
var React = __importStar(require("react"));
var PJLATestingLogo = function (_a) {
    var style = _a.style;
    return (React.createElement(renderer_1.Image, { style: style, src: "https://firebasestorage.googleapis.com/v0/b/dark-autumn-293319.appspot.com/o/assets%2FPJLA%20Testing%20-%20Color.JPG?alt=media&token=2ff9e48a-4998-4751-a675-278e503f7c84" }));
};
exports.default = PJLATestingLogo;
//# sourceMappingURL=index.js.map